import "../PropertyPage.css"
const MedioValleyPage = () => {
    return ( 
        <div className = "ppcontainer">
            <h1 className = "ppchild">Medio Valley</h1>
        </div>
     );
}
 
export default MedioValleyPage;